import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  Badge,
  Container,
  Row,
  Col,
} from 'reactstrap'
import { useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { IoCheckmark } from 'react-icons/io5'
import packageApi from '_api/package'
import { formatNumberEng } from '_utils/formatNumber'
import { useToasts } from 'react-toast-notifications'

export default function Component({ open, toggle }) {
  const [plans, setPlans] = useState([]);
  const { addToast } = useToasts()
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const { msgResp: listPlans } = await packageApi.getListPackages()
        setPlans(listPlans.slice().sort((a, b) => a.amount - b.amount))
      } catch (error) {
        console.error('Error fetching plans:', error)
      }
    }
    fetchPlans()
  }, [])

  const handlePlanSelect = (plan) => {
    let newWindow = null
    if (plan.type !== 'percent of revenue') {
      newWindow = window.open('', '_blank')
    }
    const data = { subId: plan.id }
    packageApi
      .createPayment(data)
      .then((response) => {
        if (response.msgCode === 18000) {
          if (plan.type === 'percent of revenue') {
            toggle()
            addToast('Registration successful!', {
              appearance: 'success',
              autoDismiss: true,
            })
          } else if (newWindow) {
            newWindow.location = response.msgResp.paymentLink
          }
        } else {
          console.error('No payment URL returned:', response)
          if (newWindow) newWindow.close()
        }
      })
      .catch((e) => {
        addToast(e.msgResp || 'An error occurred', {
          appearance: e.msgCode === 18007 ? 'warning' : 'error',
          autoDismiss: true,
        })
        if (newWindow) newWindow.close()
      })
  }
  return (
    <Container className='py-5'>
      <Modal isOpen={open} toggle={toggle} size='md' scrollable>
        <ModalHeader toggle={toggle} className='text-center'>
          <div className='w-100'>
            <h2 className='mb-2 fw-bold ' style={{ fontSize: '24px' }}>
              Choose Your Plan
            </h2>
            <p className='text-muted mb-0' style={{ fontSize: '18px' }}>
              Select the perfect plan for your business needs
            </p>
          </div>
        </ModalHeader>

        <ModalBody className='px-4'>
          <div className='d-flex flex-column gap-3'>
            {plans.map((plan, index) => (
              <Card
                key={index}
                className={`position-relative elevation-2 ${
                  plan.name === 'Basic' ? 'border-success border-2' : ''
                }`}
                style={{ borderRadius: '24px' }}
              >
                {plan.name === 'Basic' && (
                  <Badge
                    color='warning'
                    className='position-absolute'
                    style={{
                      top: '-10px',
                      left: '15px',
                      zIndex: 1000,
                      backgroundColor: '#ffc107',
                      color: '#000',
                    }}
                  >
                    Most Popular
                  </Badge>
                )}

                <CardBody className='p-4'>
                  <Row className='align-items-start'>
                    {/* Content */}
                    <Col>
                      <Row className='mb-3'>
                        <Col md='8'>
                          <h4 className='fw-bold mb-2' style={{ color: '#047c7a' }}>
                            {plan.name}
                          </h4>
                          <p className='text-muted small mb-0'>{plan.description}</p>
                        </Col>
                        <Col md='4' className='text-md-end'>
                          <div className='d-flex align-items-baseline justify-content-md-end gap-2'>
                            {plan.type === 'percent of revenue' ? (
                              <span className='fw-bold mb-0' style={{ fontSize: '18px' }}>
                                2% of revenue
                              </span>
                            ) : (
                              <span className='h3 fw-bold mb-0'>
                                {`$${formatNumberEng(plan.amount, 0)}`}
                              </span>
                            )}
                          </div>
                          {plan.type !== 'percent of revenue' && (
                            <p className='small text-muted mb-0'>{plan.cycle}</p>
                          )}
                        </Col>
                      </Row>

                      {/* Features */}
                      <Row className='mb-3'>
                        <Col md='12' className='mb-2'>
                          <div className='d-flex align-items-start gap-2'>
                            <span className='text-success'>
                              <IoCheckmark size={16} className='mb-2' />
                            </span>
                            <span className='small'>
                              {plan.limit === 0
                                ? 'Unlimited number of package registrations'
                                : `Limited to ${plan.limit} registrations.`}
                            </span>
                          </div>
                        </Col>
                      </Row>

                      {/* Button */}
                      <Button
                        color={'outline'}
                        className='w-100 w-md-auto'
                        onClick={() => handlePlanSelect(plan)}
                      >
                        Choose {plan.name}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ))}
          </div>
        </ModalBody>
      </Modal>
    </Container>
  )
}
